
















import { Breakpoint, getBreakpoint } from '@/shared/UI/Breakpoint';
import { Styled }                    from '@/shared/UI/Styled';
import { Component, Vue }            from 'vue-property-decorator';
import { Action }                    from 'vuex-class';
import Avatar                        from './Avatar.vue';
import Greetings                     from './Greetings.vue';
import InfoContainer                 from './InfoContainer.vue';

const namespace: string = 'profile';

@Component({
  components: {
    InfoContainer,
    Greetings,
    Avatar
  }
})
export default class BusinessCard extends Vue implements Styled {
  @Action('fetchData', { namespace })
  private fetchData: any;

  private mounted() {
    // fetching data as soon as the component's been mounted
    this.fetchData();
  }

  get styled() {
    const breakpoint = getBreakpoint(this);
    return { ...classes(breakpoint), breakpoint };
  }
}

const classes = (bp: Breakpoint) => ({
  businessCard: {
    'business-card-mobile-port': bp.xsOnly,
    'business-card-mobile-land': bp.smOnly,
    'business-card-desk': bp.mdAndUp
  },
  avatarContainer: {
    'avatar-container': true,
    'avatar-container-mobile-port': bp.xsOnly
  }
});
